module.exports = __webpack_public_path__ + "img/circleGrey.9e0a252b.svg";